module.exports = __webpack_public_path__ + "img/ceuta.c601932c.svg";